import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AddMessageReactionBody,
  CreateChatThread200,
  CreateChatThreadBody,
  GetChatThreadById200,
  GetMessages200Item,
  GetMessagesParams,
  GetPendingChatRequests200Item,
  GetUserThreads200Item,
  GetUserThreadsParams,
  InviteUsersBody,
  SearchAllMessages200Item,
  SearchAllMessagesParams,
  SearchMessages200Item,
  SearchMessagesParams,
  SendMessage200,
  SendMessageBody,
  UpdateChatThreadLastMessageBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Get chat threads for current user
 */
export const getUserThreads = (
    params?: GetUserThreadsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserThreads200Item[]>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/user-threads`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserThreadsQueryKey = (params?: GetUserThreadsParams,) => {
    return [`https://api.ugot.uk/api/chat/chat-threads/user-threads`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserThreadsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getUserThreads>>, TError = void>(params?: GetUserThreadsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserThreads>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserThreadsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserThreads>>> = ({ signal }) => getUserThreads(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserThreads>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserThreadsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUserThreads>>>
export type GetUserThreadsInfiniteQueryError = void

/**
 * @summary Get chat threads for current user
 */
export const useGetUserThreadsInfinite = <TData = Awaited<ReturnType<typeof getUserThreads>>, TError = void>(
 params?: GetUserThreadsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserThreads>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserThreadsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUserThreadsQueryOptions = <TData = Awaited<ReturnType<typeof getUserThreads>>, TError = void>(params?: GetUserThreadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserThreads>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserThreadsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserThreads>>> = ({ signal }) => getUserThreads(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserThreads>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserThreads>>>
export type GetUserThreadsQueryError = void

/**
 * @summary Get chat threads for current user
 */
export const useGetUserThreads = <TData = Awaited<ReturnType<typeof getUserThreads>>, TError = void>(
 params?: GetUserThreadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserThreads>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserThreadsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a chat thread (1:1 or group)
 */
export const createChatThread = (
    createChatThreadBody: CreateChatThreadBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateChatThread200>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createChatThreadBody
    },
      options);
    }
  


export const getCreateChatThreadMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatThread>>, TError,{data: CreateChatThreadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChatThread>>, TError,{data: CreateChatThreadBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChatThread>>, {data: CreateChatThreadBody}> = (props) => {
          const {data} = props ?? {};

          return  createChatThread(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateChatThreadMutationResult = NonNullable<Awaited<ReturnType<typeof createChatThread>>>
    export type CreateChatThreadMutationBody = CreateChatThreadBody
    export type CreateChatThreadMutationError = void

    /**
 * @summary Create a chat thread (1:1 or group)
 */
export const useCreateChatThread = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatThread>>, TError,{data: CreateChatThreadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createChatThread>>,
        TError,
        {data: CreateChatThreadBody},
        TContext
      > => {

      const mutationOptions = getCreateChatThreadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a chat thread by id
 */
export const getChatThreadById = (
    chatRoomId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetChatThreadById200>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetChatThreadByIdQueryKey = (chatRoomId: number,) => {
    return [`https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}`] as const;
    }

    
export const getGetChatThreadByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getChatThreadById>>, TError = void>(chatRoomId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChatThreadById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatThreadByIdQueryKey(chatRoomId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatThreadById>>> = ({ signal }) => getChatThreadById(chatRoomId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(chatRoomId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChatThreadById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChatThreadByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getChatThreadById>>>
export type GetChatThreadByIdInfiniteQueryError = void

/**
 * @summary Get a chat thread by id
 */
export const useGetChatThreadByIdInfinite = <TData = Awaited<ReturnType<typeof getChatThreadById>>, TError = void>(
 chatRoomId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChatThreadById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetChatThreadByIdInfiniteQueryOptions(chatRoomId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChatThreadByIdQueryOptions = <TData = Awaited<ReturnType<typeof getChatThreadById>>, TError = void>(chatRoomId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChatThreadById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatThreadByIdQueryKey(chatRoomId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatThreadById>>> = ({ signal }) => getChatThreadById(chatRoomId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(chatRoomId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatThreadById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChatThreadByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getChatThreadById>>>
export type GetChatThreadByIdQueryError = void

/**
 * @summary Get a chat thread by id
 */
export const useGetChatThreadById = <TData = Awaited<ReturnType<typeof getChatThreadById>>, TError = void>(
 chatRoomId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChatThreadById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetChatThreadByIdQueryOptions(chatRoomId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary List pending chat thread requests for current user
 */
export const getPendingChatRequests = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPendingChatRequests200Item[]>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/requests/pending`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPendingChatRequestsQueryKey = () => {
    return [`https://api.ugot.uk/api/chat/chat-threads/requests/pending`] as const;
    }

    
export const getGetPendingChatRequestsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getPendingChatRequests>>, TError = void>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingChatRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingChatRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingChatRequests>>> = ({ signal }) => getPendingChatRequests(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingChatRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPendingChatRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingChatRequests>>>
export type GetPendingChatRequestsInfiniteQueryError = void

/**
 * @summary List pending chat thread requests for current user
 */
export const useGetPendingChatRequestsInfinite = <TData = Awaited<ReturnType<typeof getPendingChatRequests>>, TError = void>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingChatRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPendingChatRequestsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPendingChatRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingChatRequests>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPendingChatRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingChatRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingChatRequests>>> = ({ signal }) => getPendingChatRequests(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingChatRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPendingChatRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingChatRequests>>>
export type GetPendingChatRequestsQueryError = void

/**
 * @summary List pending chat thread requests for current user
 */
export const useGetPendingChatRequests = <TData = Awaited<ReturnType<typeof getPendingChatRequests>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPendingChatRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPendingChatRequestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Accept a pending chat request
 */
export const acceptChatRequest = (
    chatRoomId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/requests/accept`, method: 'POST'
    },
      options);
    }
  


export const getAcceptChatRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptChatRequest>>, TError,{chatRoomId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptChatRequest>>, TError,{chatRoomId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptChatRequest>>, {chatRoomId: number}> = (props) => {
          const {chatRoomId} = props ?? {};

          return  acceptChatRequest(chatRoomId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptChatRequestMutationResult = NonNullable<Awaited<ReturnType<typeof acceptChatRequest>>>
    
    export type AcceptChatRequestMutationError = void

    /**
 * @summary Accept a pending chat request
 */
export const useAcceptChatRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptChatRequest>>, TError,{chatRoomId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof acceptChatRequest>>,
        TError,
        {chatRoomId: number},
        TContext
      > => {

      const mutationOptions = getAcceptChatRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Decline a pending chat request
 */
export const declineChatRequest = (
    chatRoomId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/requests/decline`, method: 'POST'
    },
      options);
    }
  


export const getDeclineChatRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineChatRequest>>, TError,{chatRoomId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof declineChatRequest>>, TError,{chatRoomId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineChatRequest>>, {chatRoomId: number}> = (props) => {
          const {chatRoomId} = props ?? {};

          return  declineChatRequest(chatRoomId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeclineChatRequestMutationResult = NonNullable<Awaited<ReturnType<typeof declineChatRequest>>>
    
    export type DeclineChatRequestMutationError = void

    /**
 * @summary Decline a pending chat request
 */
export const useDeclineChatRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineChatRequest>>, TError,{chatRoomId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof declineChatRequest>>,
        TError,
        {chatRoomId: number},
        TContext
      > => {

      const mutationOptions = getDeclineChatRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete (leave) chat thread for current user
 */
export const deleteChatThread = (
    chatRoomId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/requests/decline`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteChatThreadMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChatThread>>, TError,{chatRoomId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteChatThread>>, TError,{chatRoomId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChatThread>>, {chatRoomId: number}> = (props) => {
          const {chatRoomId} = props ?? {};

          return  deleteChatThread(chatRoomId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteChatThreadMutationResult = NonNullable<Awaited<ReturnType<typeof deleteChatThread>>>
    
    export type DeleteChatThreadMutationError = void

    /**
 * @summary Delete (leave) chat thread for current user
 */
export const useDeleteChatThread = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChatThread>>, TError,{chatRoomId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteChatThread>>,
        TError,
        {chatRoomId: number},
        TContext
      > => {

      const mutationOptions = getDeleteChatThreadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get messages in a chat thread
 */
export const getMessages = (
    chatRoomId: number,
    params?: GetMessagesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetMessages200Item[]>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/messages`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetMessagesQueryKey = (chatRoomId: number,
    params?: GetMessagesParams,) => {
    return [`https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/messages`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMessagesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getMessages>>, TError = void>(chatRoomId: number,
    params?: GetMessagesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesQueryKey(chatRoomId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessages>>> = ({ signal }) => getMessages(chatRoomId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(chatRoomId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMessagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMessages>>>
export type GetMessagesInfiniteQueryError = void

/**
 * @summary Get messages in a chat thread
 */
export const useGetMessagesInfinite = <TData = Awaited<ReturnType<typeof getMessages>>, TError = void>(
 chatRoomId: number,
    params?: GetMessagesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMessagesInfiniteQueryOptions(chatRoomId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getMessages>>, TError = void>(chatRoomId: number,
    params?: GetMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesQueryKey(chatRoomId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessages>>> = ({ signal }) => getMessages(chatRoomId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(chatRoomId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getMessages>>>
export type GetMessagesQueryError = void

/**
 * @summary Get messages in a chat thread
 */
export const useGetMessages = <TData = Awaited<ReturnType<typeof getMessages>>, TError = void>(
 chatRoomId: number,
    params?: GetMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMessagesQueryOptions(chatRoomId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Send a message in a chat thread
 */
export const sendMessage = (
    chatRoomId: number,
    sendMessageBody: SendMessageBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SendMessage200>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendMessageBody
    },
      options);
    }
  


export const getSendMessageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{chatRoomId: number;data: SendMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{chatRoomId: number;data: SendMessageBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMessage>>, {chatRoomId: number;data: SendMessageBody}> = (props) => {
          const {chatRoomId,data} = props ?? {};

          return  sendMessage(chatRoomId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendMessage>>>
    export type SendMessageMutationBody = SendMessageBody
    export type SendMessageMutationError = void

    /**
 * @summary Send a message in a chat thread
 */
export const useSendMessage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{chatRoomId: number;data: SendMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof sendMessage>>,
        TError,
        {chatRoomId: number;data: SendMessageBody},
        TContext
      > => {

      const mutationOptions = getSendMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Add a reaction to a message
 */
export const addMessageReaction = (
    chatRoomId: number,
    messageId: number,
    addMessageReactionBody: AddMessageReactionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/messages/${messageId}/reactions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addMessageReactionBody
    },
      options);
    }
  


export const getAddMessageReactionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMessageReaction>>, TError,{chatRoomId: number;messageId: number;data: AddMessageReactionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addMessageReaction>>, TError,{chatRoomId: number;messageId: number;data: AddMessageReactionBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addMessageReaction>>, {chatRoomId: number;messageId: number;data: AddMessageReactionBody}> = (props) => {
          const {chatRoomId,messageId,data} = props ?? {};

          return  addMessageReaction(chatRoomId,messageId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddMessageReactionMutationResult = NonNullable<Awaited<ReturnType<typeof addMessageReaction>>>
    export type AddMessageReactionMutationBody = AddMessageReactionBody
    export type AddMessageReactionMutationError = void

    /**
 * @summary Add a reaction to a message
 */
export const useAddMessageReaction = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMessageReaction>>, TError,{chatRoomId: number;messageId: number;data: AddMessageReactionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof addMessageReaction>>,
        TError,
        {chatRoomId: number;messageId: number;data: AddMessageReactionBody},
        TContext
      > => {

      const mutationOptions = getAddMessageReactionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Remove a reaction from a message
 */
export const removeMessageReaction = (
    chatRoomId: number,
    messageId: number,
    reactionType: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/messages/${messageId}/reactions/${reactionType}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemoveMessageReactionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMessageReaction>>, TError,{chatRoomId: number;messageId: number;reactionType: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeMessageReaction>>, TError,{chatRoomId: number;messageId: number;reactionType: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeMessageReaction>>, {chatRoomId: number;messageId: number;reactionType: string}> = (props) => {
          const {chatRoomId,messageId,reactionType} = props ?? {};

          return  removeMessageReaction(chatRoomId,messageId,reactionType,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveMessageReactionMutationResult = NonNullable<Awaited<ReturnType<typeof removeMessageReaction>>>
    
    export type RemoveMessageReactionMutationError = void

    /**
 * @summary Remove a reaction from a message
 */
export const useRemoveMessageReaction = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMessageReaction>>, TError,{chatRoomId: number;messageId: number;reactionType: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof removeMessageReaction>>,
        TError,
        {chatRoomId: number;messageId: number;reactionType: string},
        TContext
      > => {

      const mutationOptions = getRemoveMessageReactionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Mark a message as read
 */
export const markMessageAsRead = (
    chatRoomId: number,
    messageId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/messages/${messageId}/read`, method: 'POST'
    },
      options);
    }
  


export const getMarkMessageAsReadMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessageAsRead>>, TError,{chatRoomId: number;messageId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markMessageAsRead>>, TError,{chatRoomId: number;messageId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markMessageAsRead>>, {chatRoomId: number;messageId: number}> = (props) => {
          const {chatRoomId,messageId} = props ?? {};

          return  markMessageAsRead(chatRoomId,messageId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkMessageAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markMessageAsRead>>>
    
    export type MarkMessageAsReadMutationError = void

    /**
 * @summary Mark a message as read
 */
export const useMarkMessageAsRead = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessageAsRead>>, TError,{chatRoomId: number;messageId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof markMessageAsRead>>,
        TError,
        {chatRoomId: number;messageId: number},
        TContext
      > => {

      const mutationOptions = getMarkMessageAsReadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update chat thread last message info
 */
export const updateChatThreadLastMessage = (
    chatRoomId: number,
    updateChatThreadLastMessageBody: UpdateChatThreadLastMessageBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/last-message`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateChatThreadLastMessageBody
    },
      options);
    }
  


export const getUpdateChatThreadLastMessageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChatThreadLastMessage>>, TError,{chatRoomId: number;data: UpdateChatThreadLastMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateChatThreadLastMessage>>, TError,{chatRoomId: number;data: UpdateChatThreadLastMessageBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChatThreadLastMessage>>, {chatRoomId: number;data: UpdateChatThreadLastMessageBody}> = (props) => {
          const {chatRoomId,data} = props ?? {};

          return  updateChatThreadLastMessage(chatRoomId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChatThreadLastMessageMutationResult = NonNullable<Awaited<ReturnType<typeof updateChatThreadLastMessage>>>
    export type UpdateChatThreadLastMessageMutationBody = UpdateChatThreadLastMessageBody
    export type UpdateChatThreadLastMessageMutationError = void

    /**
 * @summary Update chat thread last message info
 */
export const useUpdateChatThreadLastMessage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChatThreadLastMessage>>, TError,{chatRoomId: number;data: UpdateChatThreadLastMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateChatThreadLastMessage>>,
        TError,
        {chatRoomId: number;data: UpdateChatThreadLastMessageBody},
        TContext
      > => {

      const mutationOptions = getUpdateChatThreadLastMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Remove a user from chat thread
 */
export const removeUserFromChatRoom = (
    chatRoomId: number,
    userId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/users/${userId}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemoveUserFromChatRoomMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUserFromChatRoom>>, TError,{chatRoomId: number;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeUserFromChatRoom>>, TError,{chatRoomId: number;userId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeUserFromChatRoom>>, {chatRoomId: number;userId: string}> = (props) => {
          const {chatRoomId,userId} = props ?? {};

          return  removeUserFromChatRoom(chatRoomId,userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveUserFromChatRoomMutationResult = NonNullable<Awaited<ReturnType<typeof removeUserFromChatRoom>>>
    
    export type RemoveUserFromChatRoomMutationError = void

    /**
 * @summary Remove a user from chat thread
 */
export const useRemoveUserFromChatRoom = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeUserFromChatRoom>>, TError,{chatRoomId: number;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof removeUserFromChatRoom>>,
        TError,
        {chatRoomId: number;userId: string},
        TContext
      > => {

      const mutationOptions = getRemoveUserFromChatRoomMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Search messages in a chat thread
 */
export const searchMessages = (
    chatRoomId: number,
    params: SearchMessagesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SearchMessages200Item[]>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/messages/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchMessagesQueryKey = (chatRoomId: number,
    params: SearchMessagesParams,) => {
    return [`https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/messages/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchMessagesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof searchMessages>>, TError = void>(chatRoomId: number,
    params: SearchMessagesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchMessagesQueryKey(chatRoomId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchMessages>>> = ({ signal }) => searchMessages(chatRoomId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(chatRoomId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchMessagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchMessages>>>
export type SearchMessagesInfiniteQueryError = void

/**
 * @summary Search messages in a chat thread
 */
export const useSearchMessagesInfinite = <TData = Awaited<ReturnType<typeof searchMessages>>, TError = void>(
 chatRoomId: number,
    params: SearchMessagesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchMessagesInfiniteQueryOptions(chatRoomId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSearchMessagesQueryOptions = <TData = Awaited<ReturnType<typeof searchMessages>>, TError = void>(chatRoomId: number,
    params: SearchMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchMessagesQueryKey(chatRoomId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchMessages>>> = ({ signal }) => searchMessages(chatRoomId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(chatRoomId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof searchMessages>>>
export type SearchMessagesQueryError = void

/**
 * @summary Search messages in a chat thread
 */
export const useSearchMessages = <TData = Awaited<ReturnType<typeof searchMessages>>, TError = void>(
 chatRoomId: number,
    params: SearchMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchMessagesQueryOptions(chatRoomId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Search messages across all threads
 */
export const searchAllMessages = (
    params: SearchAllMessagesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SearchAllMessages200Item[]>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/messages/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchAllMessagesQueryKey = (params: SearchAllMessagesParams,) => {
    return [`https://api.ugot.uk/api/chat/chat-threads/messages/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchAllMessagesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof searchAllMessages>>, TError = void>(params: SearchAllMessagesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchAllMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchAllMessagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAllMessages>>> = ({ signal }) => searchAllMessages(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchAllMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchAllMessagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchAllMessages>>>
export type SearchAllMessagesInfiniteQueryError = void

/**
 * @summary Search messages across all threads
 */
export const useSearchAllMessagesInfinite = <TData = Awaited<ReturnType<typeof searchAllMessages>>, TError = void>(
 params: SearchAllMessagesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchAllMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchAllMessagesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSearchAllMessagesQueryOptions = <TData = Awaited<ReturnType<typeof searchAllMessages>>, TError = void>(params: SearchAllMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchAllMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchAllMessagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAllMessages>>> = ({ signal }) => searchAllMessages(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAllMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchAllMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof searchAllMessages>>>
export type SearchAllMessagesQueryError = void

/**
 * @summary Search messages across all threads
 */
export const useSearchAllMessages = <TData = Awaited<ReturnType<typeof searchAllMessages>>, TError = void>(
 params: SearchAllMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchAllMessages>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchAllMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Invite users to a chat thread
 */
export const inviteUsers = (
    chatRoomId: number,
    inviteUsersBody: InviteUsersBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteUsersBody
    },
      options);
    }
  


export const getInviteUsersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUsers>>, TError,{chatRoomId: number;data: InviteUsersBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteUsers>>, TError,{chatRoomId: number;data: InviteUsersBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteUsers>>, {chatRoomId: number;data: InviteUsersBody}> = (props) => {
          const {chatRoomId,data} = props ?? {};

          return  inviteUsers(chatRoomId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteUsersMutationResult = NonNullable<Awaited<ReturnType<typeof inviteUsers>>>
    export type InviteUsersMutationBody = InviteUsersBody
    export type InviteUsersMutationError = void

    /**
 * @summary Invite users to a chat thread
 */
export const useInviteUsers = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUsers>>, TError,{chatRoomId: number;data: InviteUsersBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof inviteUsers>>,
        TError,
        {chatRoomId: number;data: InviteUsersBody},
        TContext
      > => {

      const mutationOptions = getInviteUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Leave a chat thread
 */
export const leaveChatRoom = (
    chatRoomId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/leave`, method: 'POST'
    },
      options);
    }
  


export const getLeaveChatRoomMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveChatRoom>>, TError,{chatRoomId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof leaveChatRoom>>, TError,{chatRoomId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveChatRoom>>, {chatRoomId: number}> = (props) => {
          const {chatRoomId} = props ?? {};

          return  leaveChatRoom(chatRoomId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LeaveChatRoomMutationResult = NonNullable<Awaited<ReturnType<typeof leaveChatRoom>>>
    
    export type LeaveChatRoomMutationError = void

    /**
 * @summary Leave a chat thread
 */
export const useLeaveChatRoom = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveChatRoom>>, TError,{chatRoomId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof leaveChatRoom>>,
        TError,
        {chatRoomId: number},
        TContext
      > => {

      const mutationOptions = getLeaveChatRoomMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get online users in a chat thread
 */
export const getOnlineUsers = (
    chatRoomId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/online-users`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOnlineUsersQueryKey = (chatRoomId: number,) => {
    return [`https://api.ugot.uk/api/chat/chat-threads/${chatRoomId}/online-users`] as const;
    }

    
export const getGetOnlineUsersInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOnlineUsers>>, TError = void>(chatRoomId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOnlineUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnlineUsersQueryKey(chatRoomId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnlineUsers>>> = ({ signal }) => getOnlineUsers(chatRoomId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(chatRoomId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOnlineUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnlineUsersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOnlineUsers>>>
export type GetOnlineUsersInfiniteQueryError = void

/**
 * @summary Get online users in a chat thread
 */
export const useGetOnlineUsersInfinite = <TData = Awaited<ReturnType<typeof getOnlineUsers>>, TError = void>(
 chatRoomId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOnlineUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOnlineUsersInfiniteQueryOptions(chatRoomId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOnlineUsersQueryOptions = <TData = Awaited<ReturnType<typeof getOnlineUsers>>, TError = void>(chatRoomId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnlineUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnlineUsersQueryKey(chatRoomId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnlineUsers>>> = ({ signal }) => getOnlineUsers(chatRoomId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(chatRoomId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnlineUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnlineUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getOnlineUsers>>>
export type GetOnlineUsersQueryError = void

/**
 * @summary Get online users in a chat thread
 */
export const useGetOnlineUsers = <TData = Awaited<ReturnType<typeof getOnlineUsers>>, TError = void>(
 chatRoomId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnlineUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOnlineUsersQueryOptions(chatRoomId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



